export const iconFontAwesomeMapsShip = (
	<i className="fa-solid fa-ship"></i>
);
